import config from '../config';

/* eslint-disable */
export function trackPageView(pageName) {
  window.utag_cfg_ovrd = { noview: true };

  const data = {
    page_name: `${config.omniture} : boards : ${pageName}`,
    page_name_var: pageName,
    feature: 'boards',
    feature_category: 'family history'
  };

  if (window.utag && utag.view) {
    utag.view(data);
  } else {
    window.addEventListener('tealiumReady', () => {
      utag.view(data);
    });
  }
}
/* eslint-enable */
